import { Col, Layout, Row, Space, Table } from 'antd';
import Sider from 'antd/es/layout/Sider';
import { Content } from 'antd/es/layout/layout';
import AuthApi from 'apis/AuthApi';
import { MainLayout } from 'components';
import { TransportImage } from 'components/Modules/Vehicle';
import { IUser } from 'interface/user.interface';
import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import pageTitleStore from 'store/pageTitleStore';
import HubOutlinedIcon from '@mui/icons-material/HubOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import VerticalShadesOutlinedIcon from '@mui/icons-material/VerticalShadesOutlined';
import {
  AreaChartOutlined,
  MailFilled,
  MailOutlined,
  MailTwoTone,
  PicCenterOutlined,
  PicLeftOutlined,
  StepBackwardOutlined,
  TagsOutlined,
} from '@ant-design/icons';

const ProfilePage = () => {
  const columnsName = [
    {
      title: '',
      dataIndex: 'fullName',
      render: (_: any, record: any) => <strong>{record.name}</strong>,
      width: '10px',
    },
  ];
  const columnsInfo = [
    {
      title: '',
      dataIndex: 'info',
      render: (_: any, record: any) => <strong>{record.info}</strong>,
    },
  ];
  const columnsDepartment = [
    {
      title: 'Phòng ban',
      dataIndex: 'department',
      width: '250px',
    },
    {
      title: 'Chi nhánh',
      dataIndex: 'storeName',
    },
  ];
  const columnsCompany = [
    {
      title: 'Đơn vị',
      dataIndex: 'storeAddress',
      width: '250px',
    },
    {
      title: 'Công ty',
      dataIndex: 'company',
    },
  ];

  const columnsHistory = [
    {
      title: 'STT',
      dataIndex: 'stt',
      width: '15px',
    },
    {
      title: 'Mã danh mục',
      dataIndex: 'jobCode',
    },
    {
      title: 'Tác vụ',
      dataIndex: 'jobAction',
    },
    {
      title: 'Người tạo',
      dataIndex: 'createName',
    },
    {
      title: 'Trạng thái',
      dataIndex: 'status',
    },
  ];

  const [user, setUser] = useState<IUser>();

  const [currentFile, setCurrentFile] = useState<File>();

  const { mutate: getUser, isLoading } = useMutation(AuthApi.getMe, {
    onSuccess: (response) => {
      setUser(response);
      setTitle(response.fullName);
    },
  });

  const handleFileChange = (file: File) => {
    setCurrentFile(file);
  };

  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);

  useEffect(() => {
    setBreadcrumb([{ title: <a href=""> Tài khoản</a> }]);
    const token = localStorage.getItem('token');
    if (!token) return;
    getUser();
  }, []);

  return (
    <MainLayout>
      <Content className="mt-3">
        {/* <img
          className=''
            src={
              user?.documents == null || user?.documents?.length == 0
                ? ''
                : (user?.documents[0] as string)
            }
            alt=""
          /> */}

        <>
          {/* <div style={{ marginTop: '-35px', marginBottom: '10px' }}>
            <div style={{ fontSize: '25px', color: '#00538F' }}>
              <strong>{user?.fullName}</strong>
            </div>
          </div> */}
          <Row gutter={[16, 18]} style={{ marginBottom: '1%' }}>
            <Col span={8}>
              <div style={{}}>
                <div
                  style={{ fontSize: '14px' }}
                  className="flex justify-start"
                >
                  <TagsOutlined
                    color="primary"
                    style={{
                      backgroundColor: '#E3F8FF',
                      padding: '2px',
                      marginRight: '10px',
                      borderRadius: '25%',
                      color: '#1976D2',
                      fontSize: '20px',
                    }}
                  />
                  <strong>Mã Job Title</strong>
                </div>
                <div style={{ lineBreak: 'normal', marginLeft: '35px' }}>
                  {user?.jobTitleCode}
                </div>
              </div>
            </Col>
            <Col span={8}>
              <div style={{}}>
                <div
                  style={{ fontSize: '14px' }}
                  className="flex justify-start"
                >
                  <TagsOutlined
                    color="primary"
                    style={{
                      backgroundColor: '#E3F8FF',
                      padding: '2px',
                      marginRight: '10px',
                      borderRadius: '25%',
                      color: '#1976D2',
                      fontSize: '20px',
                    }}
                  />
                  <strong>Job Title</strong>
                </div>
                <div style={{ lineBreak: 'normal', marginLeft: '35px' }}>
                  {user?.jobTitle}
                </div>
              </div>
            </Col>
            <Col span={8}>
              <div style={{}}>
                <div
                  style={{ fontSize: '14px' }}
                  className="flex justify-start"
                >
                  <PicLeftOutlined
                    style={{
                      backgroundColor: '#E3F8FF',
                      padding: '2px',
                      marginRight: '10px',
                      borderRadius: '25%',
                      color: '#1976D2',
                      fontSize: '20px',
                    }}
                  />
                  <strong>Khối</strong>
                </div>
                <div style={{ lineBreak: 'normal', marginLeft: '35px' }}>
                  {user?.division}
                </div>
              </div>
            </Col>
            <Col span={8}>
              <div>
                <div style={{ fontSize: '14px' }}>
                  <VerticalShadesOutlinedIcon
                    color="primary"
                    style={{
                      marginRight: '10px',
                      borderRadius: '25%',
                      backgroundColor: 'F1F9FF',
                    }}
                  />
                  <strong>Phòng ban</strong>
                </div>
                <div style={{ marginLeft: '35px' }}>{user?.departmentName}</div>
              </div>
            </Col>
            <Col span={8}>
              <div>
                <div style={{ fontSize: '14px' }}>
                  <HubOutlinedIcon
                    color="primary"
                    style={{
                      backgroundColor: 'F1F9FF',
                      marginRight: '10px',
                      borderRadius: '25%',
                    }}
                  />
                  <strong>Chi nhánh</strong>
                </div>
                <div style={{ marginLeft: '35px' }}>{user?.plantName}</div>
              </div>
            </Col>
            <Col span={8}>
              <div style={{}}>
                <div
                  style={{ fontSize: '14px' }}
                  className="flex justify-start"
                >
                  <MailOutlined
                    color="primary"
                    style={{
                      backgroundColor: '#E3F8FF',
                      padding: '2px',
                      marginRight: '10px',
                      borderRadius: '25%',
                      color: '#1976D2',
                      fontSize: '20px',
                    }}
                  />
                  <strong>Email</strong>
                </div>
                <div style={{ lineBreak: 'normal', marginLeft: '35px' }}>
                  {user?.email}
                </div>
              </div>
            </Col>
            <Col span={8}>
              <div style={{}}>
                <div
                  style={{ fontSize: '14px' }}
                  className="flex justify-start"
                >
                  <MailOutlined
                    color="primary"
                    style={{
                      backgroundColor: '#E3F8FF',
                      padding: '2px',
                      marginRight: '10px',
                      borderRadius: '25%',
                      color: '#1976D2',
                      fontSize: '20px',
                    }}
                  />
                  <strong>Nhóm quyền</strong>
                </div>
                <div style={{ lineBreak: 'normal', marginLeft: '35px' }}>
                  {user?.groups[0]?.name}
                </div>
              </div>
            </Col>
            <Col span={8}>
              <div>
                <div style={{ fontSize: '14px' }}>
                  <PeopleAltOutlinedIcon
                    color="primary"
                    style={{
                      backgroundColor: 'F1F9FF',
                      marginRight: '10px',
                      borderRadius: '25%',
                    }}
                  />
                  <strong>Địa chỉ</strong>
                </div>
                <div style={{ lineBreak: 'normal', marginLeft: '35px' }}>
                  {user?.plantName} ({user?.plantAddress})
                </div>
              </div>
            </Col>
            <Col span={8}>
              <div>
                <div style={{ fontSize: '14px' }}>
                  <ApartmentOutlinedIcon
                    color="primary"
                    style={{
                      backgroundColor: 'F1F9FF',
                      marginRight: '10px',
                      borderRadius: '25%',
                    }}
                  />
                  <strong>Plant</strong>
                </div>
                <div style={{ marginLeft: '35px' }}>{user?.plantCode}</div>
              </div>
            </Col>
            <Col span={8}>
              <div>
                <div style={{ fontSize: '14px' }}>
                  <PicCenterOutlined
                    style={{
                      backgroundColor: '#E3F8FF',
                      padding: '2px',
                      marginRight: '10px',
                      borderRadius: '25%',
                      color: '#1976D2',
                      fontSize: '20px',
                    }}
                  />
                  <strong>Mô hình kinh doanh</strong>
                </div>
                <div style={{ marginLeft: '35px' }}>
                  {user?.plant?.moHinhKinhDoanh}
                </div>
              </div>
            </Col>
            <Col span={8}>
              <div>
                <div style={{ fontSize: '14px' }}>
                  <AreaChartOutlined
                    style={{
                      backgroundColor: '#E3F8FF',
                      padding: '2px',
                      marginRight: '10px',
                      borderRadius: '25%',
                      color: '#1976D2',
                      fontSize: '20px',
                    }}
                  />
                  <strong>Khu vực</strong>
                </div>
                <div style={{ marginLeft: '35px' }}>
                  {user?.plant?.areaName}
                </div>
              </div>
            </Col>
          </Row>
          <>Version: 1.0.2</>
        </>
      </Content>
      {/* <Table columns={columnsHistory} size="small" /> */}
    </MainLayout>
  );
};

export default ProfilePage;
